import { StyleSheet } from 'react-native';
import type { StylesMap } from 'types';

const styles: StylesMap = {
    languagesPopup: {
        position: 'absolute',
        left: -61,
        width: 122
    },
    popupTriangle: {
        margin: 'auto',
        marginBottom: -6,
        opacity: 0.9,
        height: 24
    }
};

export default StyleSheet.create(styles);
